import { postMessageToMobileApp } from 'components/app/helpers';
import { DELTA_GLOBAL_APP_PLAY_STORE_URL } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';
import { noop } from 'helpers/utils';
import i18n from 'i18n/config';
import { RocketIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';
import MaterialDialog from 'UIKit/MaterialDialog';

import styles from './forceAppUpdatePopup.module.scss';

const appUpdateRequiredText = i18n.t('common:appUpdateRequired');
const pleaseUpdateAppText = i18n.t('common:pleaseUpdateApp');
const updateNowText = i18n.t('common:updateNow');

const ForceAppUpdatePopup = () => {
  const handleUpdateNowClick = () => {
    postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.OPEN_LINK_IN_EXTERNAL_BROWSER, {
      url: DELTA_GLOBAL_APP_PLAY_STORE_URL,
    });
  };

  return (
    <MaterialDialog fullWidth open onClose={noop} contentClassName={styles.dialogContent}>
      <RocketIcon />

      <Box as="p" textColor="primary" fontSize="md1">
        {appUpdateRequiredText}
      </Box>

      <Box as="p" textColor="secondary" fontSize="sm2">
        {pleaseUpdateAppText}
      </Box>

      <DeltaButton
        text={updateNowText}
        fullWidth
        data-testid="playstore-link"
        onClick={handleUpdateNowClick}
      />
    </MaterialDialog>
  );
};

export default ForceAppUpdatePopup;
